document.addEventListener("DOMContentLoaded", () => {

  /*====================================
    TAB SWITCHING
  ====================================*/

  const sections = document.querySelectorAll(".featured-product-tabs");

  sections.forEach((section) => {

    const buttons = section.querySelectorAll(".tab-button");
    const tabs = section.querySelectorAll(".tab-content");

    buttons.forEach((button) => {

      button.addEventListener("click", () => {

        const target = button.dataset.tab;

        buttons.forEach(btn => btn.classList.remove("active"));
        tabs.forEach(tab => tab.classList.remove("active"));

        button.classList.add("active");

        const activeTab = section.querySelector("#" + target);

        if (activeTab) {
          activeTab.classList.add("active");
        }

      });

    });

  });




  /*====================================
    PRODUCT SLIDER
  ====================================*/

  document.querySelectorAll(".slider-wrapper").forEach((wrapper) => {

    const slider = wrapper.querySelector(".product-slider");
    const prev = wrapper.querySelector(".prev");
    const next = wrapper.querySelector(".next");

    if (!slider) return;

    const getScrollAmount = () => {

      const card = slider.querySelector(".product-card");

      if (!card) return 300;

      const gap = 12;

      return card.offsetWidth + gap;

    };

    next?.addEventListener("click", () => {

      slider.scrollBy({
        left: getScrollAmount(),
        behavior: "smooth"
      });

    });

    prev?.addEventListener("click", () => {

      slider.scrollBy({
        left: -getScrollAmount(),
        behavior: "smooth"
      });

    });




    /*====================================
      TOUCH DRAG SUPPORT
    ====================================*/

    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {

      isDown = true;

      slider.classList.add("dragging");

      startX = e.pageX - slider.offsetLeft;

      scrollLeft = slider.scrollLeft;

    });

    slider.addEventListener("mouseleave", () => {

      isDown = false;

      slider.classList.remove("dragging");

    });

    slider.addEventListener("mouseup", () => {

      isDown = false;

      slider.classList.remove("dragging");

    });

    slider.addEventListener("mousemove", (e) => {

      if (!isDown) return;

      e.preventDefault();

      const x = e.pageX - slider.offsetLeft;

      const walk = (x - startX) * 1.5;

      slider.scrollLeft = scrollLeft - walk;

    });

  });





  /*====================================
      AJAX ADD TO CART
  ====================================*/

  document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
  if (button.classList.contains("disabled")) return;

  button.addEventListener("click", async () => {
    const variantId = button.dataset.variantId;

    if (!variantId) return;

    button.disabled = true;

    const originalText = button.innerHTML;
    button.innerHTML = "Adding...";

    try {

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: [
            "cart-drawer",
            "cart-icon-bubble"
          ],
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();

      button.innerHTML = "Added ✓";

      // Update Cart Drawer
      const cartDrawer = document.querySelector("cart-drawer");

      if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents(data);
      }

      // Remove empty class
      const drawer = document.querySelector(".drawer");

      if (drawer) {
          drawer.classList.remove("is-empty");
      }

      // Open Drawer
      if (cartDrawer && typeof cartDrawer.open === "function") {
        cartDrawer.open();
      }

    } catch (error) {
      console.error(error);
      button.innerHTML = "Error";
    }

    setTimeout(() => {
      button.disabled = false;
      button.innerHTML = originalText;
    }, 1500);

  });
});



  /*====================================
      KEYBOARD SUPPORT
  ====================================*/

  document.querySelectorAll(".product-slider").forEach((slider) => {

    slider.setAttribute("tabindex", "0");

    slider.addEventListener("keydown", (e) => {

      if (e.key === "ArrowRight") {

        slider.scrollBy({
          left: 300,
          behavior: "smooth"
        });

      }

      if (e.key === "ArrowLeft") {

        slider.scrollBy({
          left: -300,
          behavior: "smooth"
        });

      }

    });

  });

});